import { importMDX } from 'mdx.macro'
import { lazy } from 'react'
import * as Basic from './Basic.demo'
import * as Text from './Text.demo'
import * as Footer from './Footer.demo'
import * as Size from './Size.demo'

const Content = lazy(() => importMDX('./modal.mdx'))

export default { demoList: [Basic, Footer, Size, Text], api: Content }
